import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Info, Ruler, Calendar, Users } from "lucide-react";
import { PropertyFormData } from "./types";

interface DetailsTabProps {
  formData: PropertyFormData;
  updateFormData: (field: keyof PropertyFormData, value: string) => void;
}

export function DetailsTab({ formData, updateFormData }: DetailsTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Info className="h-4 w-4" />
          Property Details
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="square_footage">Square Footage</Label>
            <div className="relative">
              <Input
                id="square_footage"
                type="number"
                min="0"
                value={formData.square_footage}
                onChange={(e) => updateFormData('square_footage', e.target.value)}
                placeholder="2500"
              />
              <Ruler className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="total_area">Total Area (sq ft)</Label>
            <Input
              id="total_area"
              type="number"
              step="any"
              min="0"
              value={formData.total_area}
              onChange={(e) => updateFormData('total_area', e.target.value)}
              placeholder="3000.50"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="year_built">Year Built</Label>
            <div className="relative">
              <Input
                id="year_built"
                type="number"
                min="1800"
                max={new Date().getFullYear()}
                value={formData.year_built}
                onChange={(e) => updateFormData('year_built', e.target.value)}
                placeholder="1995"
              />
              <Calendar className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="number_of_units">Number of Units</Label>
            <div className="relative">
              <Input
                id="number_of_units"
                type="number"
                min="0"
                value={formData.number_of_units}
                onChange={(e) => updateFormData('number_of_units', e.target.value)}
                placeholder="1"
              />
              <Users className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
